import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from '@keen.io/ui-core';
import { getDefaultAbsoluteTime } from '@keen.io/time-utils';
import { TabsSettings } from './types';
import { DEFAULT_TIMEFRAME } from './constants';

var Navigation = function Navigation(_ref) {
  var timeframe = _ref.timeframe,
      onTimeframeChange = _ref.onTimeframeChange,
      isDisabled = _ref.isDisabled;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var tabs = [{
    label: t('query_creator_timeframe.relative'),
    id: TabsSettings.RELATIVE
  }, {
    label: t('query_creator_timeframe.absolute'),
    id: TabsSettings.ABSOLUTE
  }];
  var activeTab = typeof timeframe === 'string' ? TabsSettings.RELATIVE : TabsSettings.ABSOLUTE;
  return React.createElement(Tabs, {
    tabs: tabs,
    activeTab: activeTab,
    onClick: function onClick(tabId) {
      if (isDisabled) return;

      if (tabId === TabsSettings.RELATIVE) {
        onTimeframeChange(DEFAULT_TIMEFRAME);
      } else {
        onTimeframeChange(getDefaultAbsoluteTime());
      }
    }
  });
};

export default Navigation;